import { make } from 'vuex-pathify'

const state = {
    units: null,
    term: null,
    classification: null,
    year: null,
    category: null,
    user: null,
    activity: null,
    totalUnits: null,
    unit_type: null,
    course: null,
    repeat: false,
}

const getters = {
    norm(state) {
        return (window.store.get('activity@activity.norms') || []).find(n => {
            return n.year.id === window.store.get('activity@year')
        })
    },
    valid(state) {
        return window.store.get('activity@units') > 0
            && window.store.get('activity@year') !== (null||undefined)
            && window.store.get('activity@classification') !== (null||undefined)
            && window.store.get('activity@category') !== (null||undefined)
            && (window.store.get('activity@term') ? window.store.get('activity@course') : true)
            && (window.store.get('activity@user') ? window.store.get('activity@user') : true)
            && window.store.get('activity@activity') !== (null||undefined||'')
            && (window.store.getters['activity/hasCourse'] ? window.store.get('activity@course') !== (null||undefined) : true)
    },
    hasCourse(state) {
        return window.store.get('activity/term') !== null
    },
    unitType(state) {
        return _.get(state, ['activity', 'unit_type'], null)
    }
}

const mutations = {
    ...make.mutations(state)
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}